import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Mobile, Centered } from '@miro-site/core';
import React, { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var StickyUseTemplateMobile = function StickyUseTemplateMobile(_ref) {
  var showOnRefIntersection = _ref.showOnRefIntersection,
      templateActions = _ref.templateActions,
      actionButtonProps = _ref.actionButtonProps,
      metadataId = _ref.metadataId;

  var _useState = useState(false),
      showStickyButton = _useState[0],
      setShowStickyButton = _useState[1];

  useEffect(function () {
    var isIntersectionObserverSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window;

    if (isIntersectionObserverSupported && showOnRefIntersection !== null && showOnRefIntersection !== void 0 && showOnRefIntersection.current) {
      var element = showOnRefIntersection.current;
      var observer = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            entry = _ref3[0];

        setShowStickyButton(!entry.isIntersecting);
      }, {
        rootMargin: '200px 0px 0px 0px'
      });
      observer.observe(element);
      return function () {
        observer.unobserve(element);
      };
    }
  }, []);

  if (!showStickyButton) {
    return null;
  }

  return /*#__PURE__*/_jsx(Mobile, {
    "data-track-place": "sticky-use-template",
    children: /*#__PURE__*/_jsx(Centered, {
      $styles: {
        position: 'fixed',
        zIndex: 700,
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)'
      },
      children: actionButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        "data-track-id": "use-template",
        "data-template-id": metadataId,
        $buttonType: "primary",
        $size: "medium",
        $withArrow: true
      }, actionButtonProps), {}, {
        children: actionButtonProps.children || templateActions.USE_TEMPLATE
      })) : null
    })
  });
};

export default StickyUseTemplateMobile;